




"use strict";

export default class WerkgebiedTable {

    constructor () {
        this.changeEvent = new Event('keyup');
        this.werkgebiedInput = document.querySelector('.dt-search input[type="search"]');
        this.werkgebiedTable = document.querySelector('.tablepress-id-1');
        this.postcodeInput = document.querySelector('.postcodecheck input');

        if ( this.werkgebiedInput && this.postcodeInput ) {
            this.updateInput();
            this.postcodeInput.addEventListener('keyup', () => this.updateInput());
        }
    }

    updateInput () {
        this.werkgebiedInput.value = this.postcodeInput.value;
        this.werkgebiedInput.dispatchEvent(this.changeEvent);
        this.showWerkgebiedTable();
    }

    showWerkgebiedTable () {
        if ( this.werkgebiedInput.value ) {
            this.werkgebiedTable.classList.add('active');
        } else {
            this.werkgebiedTable.classList.remove('active');
        }
    };
}
